/**
 * RSM — Retail Safe Deposit Management routes.
 *
 *   /rsm                              → dashboard (Box Lookup / Vacant / Past Due / Access Log tabs)
 *   /rsm/box/:acctId                  → single SDB box detail (deputies + history)
 *   /rsm/box/:acctId/close            → 7-step Close-Out Wizard (jXchange-wired, flows/)
 *   /rsm/box/:acctId/escheat          → Missouri State Treasurer escheatment handoff (flows/)
 *   /rsm/box/:acctId/all-deceased     → SDB All-Owners-Deceased joint inventory wizard (Wave 2)
 */
import { Routes, Route } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import RsmDashboard from './index';
import { BoxDetail } from './BoxDetail';
import { CloseOutWizard } from './flows/CloseOutWizard';
import { EscheatmentHandoff } from './flows/EscheatmentHandoff';
import { AllOwnersDeceased } from './flows/AllOwnersDeceased';

export function RsmRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<RsmDashboard />} />
      <Route path="box/:acctId" element={<BoxDetail />} />
      <Route path="box/:acctId/close" element={<CloseOutWizard />} />
      <Route path="box/:acctId/escheat" element={<EscheatmentHandoff />} />
      <Route path="box/:acctId/all-deceased" element={<AllOwnersDeceased />} />
      <Route path="*" element={<SplatRedirect />} />
    </Routes>
  );
}
